import { render } from "./BrandConnect.vue?vue&type=template&id=305906b9&scoped=true"
import script from "./BrandConnect.vue?vue&type=script&lang=js"
export * from "./BrandConnect.vue?vue&type=script&lang=js"

import "./BrandConnect.vue?vue&type=style&index=0&id=305906b9&lang=less&scoped=true"
import "./BrandConnect.vue?vue&type=style&index=1&id=305906b9&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-305906b9"]])

export default __exports__